export const FeatureFlightChanged = "FeatureFlightChanged"

export const FlightingChanged = (data:any) => {
    return {
        type:FeatureFlightChanged,
        payload:data
    }
}

export {}